export default "__VITE_ASSET__DeZSOJ0z__"